module.exports = __webpack_public_path__ + "img/logo.d2762699.png";